import request from '@/utils/request'

export function getOrderList(params) {
	return request({
		url: '/api/order/list',
		method: 'get',
		params
	})
}

// 获取余额明细列表
export function getBalanceRecords(params) {
	return request({
		url: '/api/order/balance/record',
		method: 'get',
		params
	})
}

// 创建充值订单
export function createRechargeOrder(data) {
	return request({
		url: '/api/order/create/recharge',
		method: 'get',
		params: data
	})
}

// 微信支付
export function miniAppPay(data) {
	return request({
		url: '/wxPay/miniAppPay',
		method: 'get',
		params: data
	})
}

// 创建课程购买订单
export function createOrder(data) {
	return request({
		url: '/api/order/create',
		method: 'get',
		params: data
	})
}

// 创建会员购买订单
export function createMemberOrder(data) {
	return request({
		url: '/api/order/create/member',
		method: 'get',
		params: data
	})
}